import axios from "./newAioxs";

// 新 短信登陆
export const LoginBySmsAPI = (data) => {
  return axios({ url: "/v2/sms", method: "POST", data });
};

// 新 账户密码登陆
export const LoginByAccountAPI = (data) => {
  return axios({ url: "/v2/account", method: "POST", data: data });
};

// 新 渠道登陆
export const LoginByChannelAPI = (data) => {
  return axios({ url: "/v2/role/channel/binds", method: "POST", data });
};

// 新 登出
export const LogoutAPI = (data) => {
  return axios({ url: "/v2/login/out", method: "POST", data });
};

// 新 获取验证码
export const GetCodeAPI = (data) => {
  return axios({ url: "/v2/sms/send", method: "POST", data });
};

// 免密短信登陆
export const LoginBySmsFreeAPI = (data) => {
  return axios({ url: "/login/free/sms", method: "POST", data });
};

// 新 免密账户密码登陆
export const LoginByAccountFreeAPI = (data) => {
  return axios({ url: "/v2/game/single/sign", method: "POST", data });
};



// WEBPACK FOOTER //
// ./src/pages/tideng/new-version/new-login.js